export const MULTI_SELECT_FILTER_MIN_ITEMS_COUNT: number = 5;

export const MULTI_SELECT_DROPDOWN_DEFAULT_MAX_HEIGHT: number = 110;
